import React, { useEffect, useState } from "react";
import { makeStyles } from "@material-ui/core/styles";
import { Grid, Card, Typography } from '@material-ui/core';
import { useDispatch, useSelector } from "react-redux";
import TableGeneric from "../../compartidos/abms/TableGeneric";
import BuscadorAbm from "../../compartidos/abms/BuscadorAbm";
import ModalAbm from "../../compartidos/abms/ModalAbm";
import { buscarReporte,setReporte,fetchReportesTodos, generateExcelReportesArea, generatePDFReportesArea } from "../../../actions/reportes";
import {MODIFICACION_PERMISOS_REPORTES } from "../../../utils/permisos";
import {FormReportesPorArea} from "./FormReportesPorArea";
import AccionesGenericoAbm from "../../compartidos/abms/AccionesGenericoAbm";
import ToolbarXLSPDF from "../../compartidos/ToolbarXLSPDF";
import { useReactToPrint } from "react-to-print";

const useStyles = makeStyles({
  root: {
    margin: "1rem auto",
    paddingLeft:0
  }
});

export const HomeReportesPorArea = (props) => {
  const dispatch = useDispatch();
  const classes = useStyles();
  
  const { items } = useSelector((state) => state.reportes);

  const componentRef = React.useRef();
  const handlePrint = useReactToPrint({
    content: () => componentRef.current,
  });

  const [open, setOpen] = useState(false);
  const [tipo, setTipo] = useState(false);

  const handleSearch = (textoBuscado) => {
    dispatch(buscarReporte(textoBuscado));
  }

  const handleTipoSelect = (item) => {
    setTipo(item)
    setOpen(true)
  }

  const handleSave = (item) => {
    dispatch(setReporte(item.idReporte,item.descripcionReporte,item.reportesRoles,item.reportesAreas, item.reportesCentrosMedicos));
  }

  useEffect(() => {
    dispatch(fetchReportesTodos());
    // eslint-disable-next-line
  }, [dispatch]);

  return (
    <div>
      <Grid container justify="center">
        <ModalAbm title="Modificar tipo de reporte" open={open} setOpen={setOpen}>
          <FormReportesPorArea form={tipo} handleSave={handleSave} permisoEdit={MODIFICACION_PERMISOS_REPORTES.MODIFICACION} />
        </ModalAbm>
        <Grid item xs={12} md={6} className={classes.root}>
          <BuscadorAbm title="Buscar reportes" handleSearch={handleSearch} />
        </Grid>
        <Card>
          <Grid item xs={12} md={12}>
            <Grid container justify="space-between" alignItems="center" style={{marginTop:1}}>
              <Grid item >
                  <Typography style={{marginLeft:'1rem'}}>
                      Listado de Reportes por Area
                  </Typography>
              </Grid>
              <Grid item>
                  <ToolbarXLSPDF
                      handlePrint={handlePrint}
                      handleExportExcel={() => dispatch(generateExcelReportesArea())}
                      handleGeneratePdf={() => dispatch(generatePDFReportesArea())}
                  />
              </Grid>
              <TableGeneric
                data={items}
                columns={[
                  {
                    label:"",
                    customBody:(item) => (
                      <AccionesGenericoAbm
                        item={item}
                        handleItemSelect={handleTipoSelect}
                      />
                    )
                  },
                  {
                    label: "Reporte",
                    id: "nombre",
                    sort: true
                  },
                  {
                    label: "Descripcion",
                    id: "descripcionReporte",
                    sort: true
                  },
                ]}
              />
            </Grid>
          </Grid>
        </Card>
      </Grid>
    </div>
  );

};